// Imports
import { Component } from '@angular/core';

import '../style/styles.css';

@Component({
    selector: 'my-app',
    template: require('./app.component.html')
})
export class AppComponent {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/app.component.ts